<template>
  <div class="profile-card">
    <div class="profile-info">
      <div class="profile-image">
        <img v-if="user.avatar" :src="user.avatar" :alt="user.displayName" />
        <span v-else class="avatar-placeholder demi">{{ displayNameFirstLetter }}</span>
      </div>
      <div class="profile-details">
        <h1 class="profile-name">{{ user.displayName }}</h1>
        <h2 class="profile-date">Member Since {{ user.createdDate }}</h2>
        <div v-show="betaPill" class="beta-pill">Beta</div>
      </div>
      <div class="profile-actions">
        <a
          v-if="editProfile"
          href="/my/account"
          class="profile-action btn material -no-border -ico-only"
          aria-label="Edit Profile"
        >
          <i class="material-symbols-outlined fill btn-ico" aria-hidden="true">manage_accounts</i>
        </a>
        <a
          v-if="viewDashboard"
          href="/my/dashboard"
          class="profile-action btn material -no-border -ico-only"
          aria-label="View Dashboard"
        >
          <i class="material-symbols-outlined fill btn-ico" aria-hidden="true">dashboard</i>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * Profile header
 */
import { storeToRefs } from 'pinia'
import { useUserAuthStore } from '@/stores/user-auth'

/** PROPS */
withDefaults(
  defineProps<{
    betaPill?: boolean
    editProfile?: boolean
    viewDashboard?: boolean
  }>(),
  {
    betaPill: false,
    editProfile: false,
    viewDashboard: false,
  },
)

/** STATE **/
const userAuthStore = useUserAuthStore()
const { user, displayNameFirstLetter } = storeToRefs(userAuthStore)
</script>
